import RouterView from '../components/RouterView.vue'

import MemberListView from '../pages/admin/views/member/MemberListView.vue'
import MemberDetailView from '../pages/admin/views/member/MemberDetailView.vue'
import UserGbHistoryListView from "../pages/admin/views/member/UserGbHistoryListView.vue";
import MemberJobFairDetailView from "../pages/admin/views/member/MemberJobFairDetailView.vue";

import CorporationListView from '../pages/admin/views/corporation/CorporationListView.vue'
import CorporationDetailView from "../pages/admin/views/corporation/CorporationDetailView.vue";
import CorporationJobFairDetailView from "../pages/admin/views/corporation/CorporationJobFairDetailView.vue";
import CorporationInfoUpdateView from "../pages/admin/views/corporation/detail/CorporationInfoUpdateView.vue";
import CorporationPromotionJobApplyStateView
    from "../pages/admin/views/corporation/CorporationPromotionJobApplyStateView.vue";

import LectureListView from '../pages/admin/views/lecture/LectureListView.vue'
import LectureCreateView from '../pages/admin/views/lecture/LectureCreateView.vue'
import LectureDetailView from '../pages/admin/views/lecture/LectureDetailView.vue'
import LectureUpdateView from '../pages/admin/views/lecture/LectureUpdateView.vue'
import LectureCourseCreateView from '../pages/admin/views/lecture/LectureCourseCreateView.vue'
import LectureMainView from '../pages/admin/views/lecture/LectureMainView.vue'

import LectureCertificateTemplateManageView from '../pages/admin/views/lecture/LectureCertificateTemplateManageView.vue'
import LectureCertificateTemplateCreateView from '../pages/admin/views/lecture/LectureCertificateTemplateCreateView.vue'
import LectureCertificateTemplateUpdateView from '../pages/admin/views/lecture/LectureCertificateTemplateUpdateView.vue'
import LectureCertificateTemplateDetailView from '../pages/admin/views/lecture/LectureCertificateTemplateDetailView.vue'

import LectureSurveyQuestionListView from '../pages/admin/views/lecture/survey/LectureSurveyQuestionListView.vue'
import LectureSurveyQuestionCreateView from '../pages/admin/views/lecture/survey/LectureSurveyQuestionCreateView.vue'
import LectureSurveyQuestionDetailView from '../pages/admin/views/lecture/survey/LectureSurveyQuestionDetailView.vue'
import LectureSurveyPaperListView from '../pages/admin/views/lecture/survey/LectureSurveyPaperListView.vue'
import LectureSurveyPaperCreateView from '../pages/admin/views/lecture/survey/LectureSurveyPaperCreateView.vue'
import LectureSurveyPaperDetailView from '../pages/admin/views/lecture/survey/LectureSurveyPaperDetailView.vue'

import LectureCourseListView from '../pages/admin/views/course/LectureCourseListView.vue'
import LectureCourseDetailView from '../pages/admin/views/course/LectureCourseDetailView.vue'

import ManagerListView from '../pages/admin/views/manager/ManagerListView.vue'
import ManagerCreateView from '../pages/admin/views/manager/ManagerCreateView.vue'
import ManagerDetailView from '../pages/admin/views/manager/ManagerDetailView.vue'
import ManagerUpdateView from '../pages/admin/views/manager/ManagerUpdateView.vue'

import UserMatchingListView from "../pages/admin/views/matching/UserMatchingListView.vue";
import UserMatchingResumeApplyListView from "../pages/admin/views/matching/UserMatchingResumeApplyListView.vue";
import MatchingListView from "../pages/admin/views/matching/MatchingListView.vue";
import MatchingApplyListView from "../pages/admin/views/matching/MatchingApplyListView.vue";

import OjfListView from "../pages/admin/views/jobfair/OjfListView.vue";
import OjfDetailView from "../pages/admin/views/jobfair/OjfDetailView.vue";
import OjfCreateView from "../pages/admin/views/jobfair/OjfCreateView.vue";
import OjfUpdateView from "../pages/admin/views/jobfair/OjfUpdateView.vue";
import JobNoticeUpdateView from "../pages/admin/views/jobfair/JobNoticeUpdateView.vue";

import JoinStateView from "../pages/admin/views/jobfair/joinstate/JoinStateView.vue";
import JoinStateDetailView from "../pages/admin/views/jobfair/joinstate/JoinStateDetailView.vue";

import ApprovedJoinStateView from "../pages/admin/views/jobfair/approvedjoinstate/ApprovedJoinStateView.vue";
import ApprovedJoinStateDetailView
    from "../pages/admin/views/jobfair/approvedjoinstate/ApprovedJoinStateDetailView.vue";

import PartnerListView from "../pages/admin/views/partner/PartnerListView.vue";
import PartnerCreateView from "../pages/admin/views/partner/PartnerCreateView.vue";
import PartnerDetailView from "../pages/admin/views/partner/PartnerDetailView.vue";
import PartnerUpdateView from "../pages/admin/views/partner/PartnerUpdateView.vue";

import SiteMainBannerView from '../pages/admin/views/site/SiteMainBannerView.vue'
import SiteCorpBannerView from '../pages/admin/views/site/SiteCorpBannerView.vue'
import SiteCurriculumManageView from '../pages/admin/views/site/SiteCurriculumManageView.vue'
import SiteCurriculumCreateView from '../pages/admin/views/site/SiteCurriculumCreateView.vue'
import SiteCurriculumUpdateView from '../pages/admin/views/site/SiteCurriculumUpdateView.vue'
import SiteCurriculumDetailView from '../pages/admin/views/site/SiteCurriculumDetailView.vue'

import MailSMSHistoryView from '../pages/admin/views/mail/MailSMSHistoryView.vue'
import MailSMSHistoryMailCreateView from '../pages/admin/views/mail/MailSMSHistoryMailCreateView.vue'
import MailSMSHistorySMSCreateView from '../pages/admin/views/mail/MailSMSHistorySMSCreateView.vue'
import MailSMSTemplateView from '../pages/admin/views/mail/MailSMSTemplateView.vue'
import MailSMSTemplateUpdateView from '../pages/admin/views/mail/MailSMSTemplateUpdateView.vue'

import CSNotifyListView from '../pages/admin/views/cs/notice/CSNotifyListView.vue'
import CSNotifyCreateView from '../pages/admin/views/cs/notice/CSNotifyCreateView.vue'
import CSNotifyUpdateView from '../pages/admin/views/cs/notice/CSNotifyUpdateView.vue'
import CSNotifyDetailView from '../pages/admin/views/cs/notice/CSNotifyDetailView.vue'
import CSFAQListView from '../pages/admin/views/cs/faq/CSFAQListView.vue'
import CSFAQCreateView from '../pages/admin/views/cs/faq/CSFAQCreateView.vue'
import CSFAQUpdateView from '../pages/admin/views/cs/faq/CSFAQUpdateView.vue'
import CSFAQDetailView from '../pages/admin/views/cs/faq/CSFAQDetailView.vue'
import CSQNAListView from '../pages/admin/views/cs/qna/CSQNAListView.vue'
import CSQNADetailView from '../pages/admin/views/cs/qna/CSQNADetailView.vue'
import CSNewsletterListView from '../pages/admin/views/cs/newsletter/CSNewsletterListView.vue'
import CSNewsletterCreateView from '../pages/admin/views/cs/newsletter/CSNewsletterCreateView.vue'
import CSNewsletterUpdateView from '../pages/admin/views/cs/newsletter/CSNewsletterUpdateView.vue'
import CSNewsletterDetailView from '../pages/admin/views/cs/newsletter/CSNewsletterDetailView.vue'
import CSRecruitInfoListView from "@/pages/admin/views/cs/recruitInfo/CSRecruitInfoListView.vue";
import CSRecruitInfoCreateView from "@/pages/admin/views/cs/recruitInfo/CSRecruitInfoCreateView.vue";
import CSRecruitInfoDetailView from "@/pages/admin/views/cs/recruitInfo/CSRecruitInfoDetailView.vue";
import CSRecruitInfoUpdateView from "@/pages/admin/views/cs/recruitInfo/CSRecruitInfoUpdateView.vue";

export default [
    {
        path: '/admin',
        redirect: '/signin/admin',
        children: [
            {
                path: 'member',
                component: RouterView,
                meta: {
                    title: '회원 관리',
                    requiresAuth: true,
                    admin: true,
                },
                children: [
                    {
                        path: '',
                        name: 'MemberList',
                        component: MemberListView,
                        meta: {
                            title: '회원 목록',
                        }
                    },
                    {
                        path: 'detail/:id',
                        name: 'MemberDetail',
                        component: MemberDetailView,
                        meta: {
                            title: '회원 상세',
                        }
                    },
                    {
                        path: 'userGbHistory',
                        name: 'UserGbHistoryListView',
                        component: UserGbHistoryListView,
                        meta: {
                            title: '회원 유형 변경 현황',
                        }
                    },
                    {
                        path: 'jobFair',
                        name: 'MemberJobFairDetail',
                        component: MemberJobFairDetailView,
                        meta: {
                            title: '특별채용관 참가 현황',
                        }
                    },
                ]
            },
            {
                path: 'corporation',
                component: RouterView,
                meta: {
                    title: '기업 관리',
                    requiresAuth: true,
                    admin: true,
                },
                children: [
                    {
                        path: '',
                        component: RouterView,
                        meta: {
                            title: '기업 목록',
                        },
                        children: [
                            {
                                path: '',
                                name: 'CorporationList',
                                component: CorporationListView,
                                meta: {
                                    title: '기업 목록',
                                }
                            },
                            {
                                path: 'detail/:id',
                                name: 'CorporationDetail',
                                component: CorporationDetailView,
                                meta: {
                                    title: '기업 상세',
                                }
                            },
                            {
                                path: 'update/:id',
                                name: 'CorporationInfoUpdate',
                                component: CorporationInfoUpdateView,
                                meta: {
                                    title: '기업 수정',
                                }
                            },
                            {
                                path: 'jobFair',
                                name: 'CorporationJobFairDetail',
                                component: CorporationJobFairDetailView,
                                meta: {
                                    title: '기업 특별채용관 상세',
                                }
                            },
                            {
                                path: 'jobApply',
                                name: 'CorporationPromotionJobApplyState',
                                component: CorporationPromotionJobApplyStateView,
                                meta: {
                                    title: '기업홍보관 입사지원 현황',
                                }
                            },
                        ]
                    },
                ]
            },
            {
                path: 'lecture',
                component: RouterView,
                meta: {
                    title: '강의 관리',
                    requiresAuth: true,
                    admin: true,
                },
                redirect: '/admin/lecture/manage',
                children: [
                    {
                        path: 'manage',
                        component: RouterView,
                        meta: {
                            title: '강의 목록',
                        },
                        children: [
                            {
                                path: '',
                                name: 'LectureList',
                                component: LectureListView,
                                meta: {
                                    title: '강의 목록',
                                }
                            },
                            {
                                path: 'create',
                                name: 'LectureCreate',
                                component: LectureCreateView,
                                meta: {
                                    title: '강의 등록',
                                }
                            },
                            {
                                path: 'course',
                                name: 'LectureCourseCreate',
                                component: LectureCourseCreateView,
                                meta: {
                                    title: '차시 등록',
                                }
                            },
                            {
                                path: 'detail/:id',
                                name: 'LectureDetail',
                                component: LectureDetailView,
                                meta: {
                                    title: '강의 상세',
                                }
                            },
                            {
                                path: 'update/:id',
                                name: 'LectureUpdate',
                                component: LectureUpdateView,
                                meta: {
                                    title: '강의 수정',
                                }
                            },
                        ]
                    },
                    {
                        path: 'main',
                        name: 'LectureMain',
                        component: LectureMainView,
                        meta: {
                            title: '대표 강의 설정',
                        }
                    },
                    {
                        path: 'survey',
                        component: RouterView,
                        meta: {
                            title: '만족도 평가',
                        },
                        redirect: '/admin/lecture/survey/surveyQuestion',
                        children: [
                            {
                                path: 'surveyQuestion',
                                component: RouterView,
                                meta: {
                                    title: '문항 관리',
                                },
                                children: [
                                    {
                                        path: '',
                                        name: 'LectureSurveyQuestionList',
                                        component: LectureSurveyQuestionListView,
                                        meta: {
                                            title: '문항 관리',
                                        }
                                    },
                                    {
                                        path: 'create/:id',
                                        name: 'LectureSurveyQuestionCreate',
                                        component: LectureSurveyQuestionCreateView,
                                        meta: {
                                            title: '문항 등록하기',
                                        }
                                    },
                                    {
                                        path: 'detail/:id',
                                        name: 'LectureSurveyQuestionDetail',
                                        component: LectureSurveyQuestionDetailView,
                                        meta: {
                                            title: '문항 상세',
                                        }
                                    },
                                ],
                            },
                            {
                                path: 'surveyPaper',
                                component: RouterView,
                                meta: {
                                    title: '평가 관리',
                                },
                                children: [
                                    {
                                        path: '',
                                        name: 'LectureSurveyPaperList',
                                        component: LectureSurveyPaperListView,
                                        meta: {
                                            title: '평가 관리',
                                        }
                                    },
                                    {
                                        path: 'create/:id',
                                        name: 'LectureSurveyPaperCreate',
                                        component: LectureSurveyPaperCreateView,
                                        meta: {
                                            title: '평가 등록하기',
                                        }
                                    },
                                    {
                                        path: 'detail/:id',
                                        name: 'LectureSurveyPaperDetail',
                                        component: LectureSurveyPaperDetailView,
                                        meta: {
                                            title: '평가 관리 상세 ',
                                        }
                                    }
                                ]
                            },
                        ]
                    },
                    {
                        path: 'certificateTemplate',
                        meta: {
                            title: '수료증 양식 관리',
                        },
                        children: [
                            {
                                path: '',
                                name: 'LectureCertificateTemplateManage',
                                component: LectureCertificateTemplateManageView,
                                meta: {
                                    title: '수료증 양식 관리',
                                }
                            },
                            {
                                path: 'create',
                                name: 'LectureCertificateTemplateCreate',
                                component: LectureCertificateTemplateCreateView,
                                meta: {
                                    title: '수료증 양식 등록',
                                }
                            },
                            {
                                path: 'update/:id',
                                name: 'LectureCertificateTemplateUpdate',
                                component: LectureCertificateTemplateUpdateView,
                                meta: {
                                    title: '수료증 양식 수정',
                                }
                            },
                            {
                                path: 'detail/:id',
                                name: 'LectureCertificateTemplateDetail',
                                component: LectureCertificateTemplateDetailView,
                                meta: {
                                    title: '수료증 양식 상세',
                                }
                            },
                        ]
                    },
                ]
            },
            {
                path: 'course',
                component: RouterView,
                meta: {
                    title: '수강 관리',
                    requiresAuth: true,
                    admin: true,
                },
                children: [
                    {
                        path: '',
                        name: 'LectureCourseList',
                        component: LectureCourseListView,
                        meta: {
                            title: '수강 관리',
                        }
                    },
                    {
                        path: ':id',
                        name: 'LectureCourseDetail',
                        component: LectureCourseDetailView,
                        meta: {
                            title: '수강 관리',
                        }
                    },
                ]
            },
            {
                path: 'manager',
                component: RouterView,
                meta: {
                    title: '관리자 관리',
                    requiresAuth: true,
                    admin: true,
                },
                children: [
                    {
                        path: '',
                        name: 'ManagerList',
                        component: ManagerListView,
                        meta: {
                            title: '관리자 목록',
                        }
                    },
                    {
                        path: 'create',
                        name: 'ManagerCreate',
                        component: ManagerCreateView,
                        meta: {
                            title: '관리자 생성',
                        }
                    },
                    {
                        path: 'detail/:id',
                        name: 'ManagerDetail',
                        component: ManagerDetailView,
                        meta: {
                            title: '관리자 상세',
                        }
                    },
                    {
                        path: 'update/:id',
                        name: 'ManagerUpdate',
                        component: ManagerUpdateView,
                        meta: {
                            title: '관리자 수정',
                        }
                    },
                ]
            },
            {
                path: 'matching',
                component: RouterView,
                meta: {
                    title: '상시채용관',
                    requiresAuth: true,
                    admin: true,
                },
                children: [
                    {
                        path: 'userMatching',
                        name: 'UserMatchingList',
                        component: UserMatchingListView,
                        meta: {
                            title: '회원별 받은제안 현황',
                        }
                    },
                    {
                        path: 'userResumeApply',
                        name: 'UserMatchingResumeApplyList',
                        component: UserMatchingResumeApplyListView,
                        meta: {
                            title: '회원별 입사지원 현황',
                        }
                    },
                    {
                        path: 'corpMatching',
                        name: 'MatchingList',
                        component: MatchingListView,
                        meta: {
                            title: '기업별 채용제안 현황',
                        }
                    },
                    {
                        path: 'detail/:id',
                        name: 'MatchingCorpDetail',
                        component: CorporationDetailView,
                        meta: {
                            title: '기업별 상세',
                        }
                    },
                    {
                        path: 'corpMatchingApply',
                        name: 'MatchingApplyList',
                        component: MatchingApplyListView,
                        meta: {
                            title: '기업별 입사지원 현황',
                        }
                    },
                ]
            },
            {
                path: 'jobfair',
                component: RouterView,
                meta: {
                    title: '온라인 특별채용관',
                    requiresAuth: true,
                    admin: true,
                },
                children: [
                    {
                        path: 'ojfList',
                        component: RouterView ,
                        meta: {
                            title: '행사 목록',
                        },
                        children: [
                            {
                                path: '',
                                name: 'OjfList',
                                component: OjfListView,
                                meta: {
                                    title: '행사 목록',
                                }
                            },
                            {
                                path: 'detail/:id',
                                name: 'OjfDetail',
                                component: OjfDetailView,
                                meta: {
                                    title: '행사 상세',
                                }
                            },
                            {
                                path: 'create/:id',
                                name: 'OjfCreate',
                                component: OjfCreateView,
                                meta: {
                                    title: '행사 등록',
                                }
                            },
                            {
                                path: 'update/:id',
                                name: 'OjfUpdate',
                                component: OjfUpdateView,
                                meta: {
                                    title: '행사 수정',
                                }
                            },
                        ]
                    },
                    {
                        path: 'joinState',
                        component: RouterView,
                        meta: {
                            title: '신청 현황',
                        },
                        children: [
                            {
                                path: '',
                                name: 'JoinState',
                                component: JoinStateView,
                                meta: {
                                    title: '신청 현황',
                                }
                            },
                            {
                                path: 'detail/:id',
                                name: 'JoinStateDetail',
                                component: JoinStateDetailView,
                                meta: {
                                    title: '신청 현황 상세',
                                }
                            },
                        ]
                    },
                    {
                        path: 'approvedJoinState',
                        component: RouterView,
                        meta: {
                            title: '참가 현황',
                        },
                        children: [
                            {
                                path: '',
                                name: 'ApprovedJoinState',
                                component: ApprovedJoinStateView,
                                meta: {
                                    title: '참가 현황',
                                }
                            },
                            {
                                path: 'detail/:id',
                                name: 'ApprovedJoinStateDetail',
                                component: ApprovedJoinStateDetailView,
                                meta: {
                                    title: '참가 현황 상세',
                                }
                            },
                            {
                                path: 'jobNoticeUpdate',
                                name: 'JobNoticeUpdate',
                                component: JobNoticeUpdateView,
                                meta: {
                                    title: '채용공고 수정',
                                }
                            },
                        ]
                    },
                ]
            },
            {
                path: 'partner',
                component: RouterView,
                meta: {
                    title: '담당기관 관리',
                    requiresAuth: true,
                    admin: true,
                },
                children: [
                    {
                        path: '',
                        name: 'PartnerList',
                        component: PartnerListView,
                        meta: {
                            title: '담당기관 목록',
                        }
                    },
                    {
                        path: 'create',
                        name: 'PartnerCreate',
                        component: PartnerCreateView,
                        meta: {
                            title: '담당기관 등록',
                        }
                    },
                    {
                        path: 'detail/:id',
                        name: 'PartnerDetail',
                        component: PartnerDetailView,
                        meta: {
                            title: '담당기관 상세',
                        }
                    },
                    {
                        path: 'update/:id',
                        name: 'PartnerUpdate',
                        component: PartnerUpdateView,
                        meta: {
                            title: '담당기관 수정',
                        }
                    },
                ]
            },
            {
                path: 'site',
                component: RouterView,
                meta: {
                    title: '사이트 관리',
                    requiresAuth: true,
                    admin: true,
                },
                redirect: '/admin/site/main_banner',
                children: [
                    {
                        path: 'main_banner',
                        name: 'SiteMainBanner',
                        component: SiteMainBannerView,
                        meta: {
                            title: '메인 배너 관리',
                        }
                    },
                    {
                        path: 'corp_banner',
                        name: 'SiteCorpBanner',
                        component: SiteCorpBannerView,
                        meta: {
                            title: '기업 홍보 배너 관리',
                        }
                    },
                    {
                        path: 'curriculum',
                        meta: {
                            title: '총괄표 관리',
                        },
                        children: [
                            {
                                path: '',
                                name: 'SiteCurriculumManage',
                                component: SiteCurriculumManageView,
                                meta: {
                                    title: '총괄표 목록',
                                }
                            },
                            {
                                path: 'create',
                                name: 'SiteCurriculumCreate',
                                component: SiteCurriculumCreateView,
                                meta: {
                                    title: '총괄표 등록',
                                }
                            },
                            {
                                path: 'update/:id',
                                name: 'SiteCurriculumUpdate',
                                component: SiteCurriculumUpdateView,
                                meta: {
                                    title: '총괄표 수정',
                                }
                            },
                            {
                                path: ':id',
                                name: 'SiteCurriculumDetail',
                                component: SiteCurriculumDetailView,
                                meta: {
                                    title: '총괄표 상세',
                                }
                            },
                        ]
                    },
                ]
            },
            {
                path: 'mail',
                component: RouterView,
                meta: {
                    title: '메일/메시지 관리',
                    requiresAuth: true,
                    admin: true,
                },
                redirect: '/admin/mail/history',
                children: [
                    {
                        path: 'history',
                        component: RouterView,
                        meta: {
                            title: '전송 내역',
                        },
                        children: [
                            {
                                path: '',
                                name: 'MailSMSHistory',
                                component: MailSMSHistoryView,
                                meta: {
                                    title: '전송 내역',
                                }
                            },
                            {
                                path: 'mail_create',
                                name: 'MailSMSHistoryMailCreate',
                                component: MailSMSHistoryMailCreateView,
                                meta: {
                                    title: '메일 쓰기',
                                }
                            },
                            {
                                path: 'sms_create',
                                name: 'MailSMSHistorySMSCreate',
                                component: MailSMSHistorySMSCreateView,
                                meta: {
                                    title: '메시지 쓰기',
                                }
                            },
                        ]
                    },
                    {
                        path: 'template',
                        component: RouterView,
                        meta: {
                            title: '템플릿 관리',
                        },
                        children: [
                            {
                                path: '',
                                name: 'MailSMSTemplate',
                                component: MailSMSTemplateView,
                                meta: {
                                    title: '템플릿 관리',
                                }
                            },
                            {
                                path: ':id',
                                name: 'MailSMSTemplateUpdate',
                                component: MailSMSTemplateUpdateView,
                                meta: {
                                    title: '템플릿 수정',
                                }
                            },
                        ]
                    },
                ]
            },
            {
                path: 'cs',
                component: RouterView,
                meta: {
                    title: '고객센터',
                    requiresAuth: true,
                    admin: true,
                },
                redirect: '/admin/cs/notice',
                children: [
                    {
                        path: 'notice',
                        component: RouterView,
                        meta: {
                            title: '공지사항',
                        },
                        children: [
                            {
                                path: '',
                                name: 'CSNotifyList',
                                component: CSNotifyListView,
                                meta: {
                                    title: '공지사항',
                                }
                            },
                            {
                                path: 'create',
                                name: 'CSNotifyCreate',
                                component: CSNotifyCreateView,
                                meta: {
                                    title: '공지사항 작성',
                                }
                            },
                            {
                                path: ':id',
                                name: 'CSNotifyDetail',
                                component: CSNotifyDetailView,
                                meta: {
                                    title: '공지사항 상세',
                                }
                            },
                            {
                                path: 'update/:id',
                                name: 'CSNotifyUpdate',
                                component: CSNotifyUpdateView,
                                meta: {
                                    title: '공지사항 수정',
                                }
                            },
                        ]
                    },
                    {
                        path: 'recruitInfo',
                        component: RouterView,
                        meta: {
                            title: '채용정보',
                        },
                        children: [
                            {
                                path: '',
                                name: 'CSRecruitInfoList',
                                component: CSRecruitInfoListView,
                                meta: {
                                    title: '채용정보',
                                }
                            },
                            {
                                path: 'create',
                                name: 'CSRecruitInfoCreate',
                                component: CSRecruitInfoCreateView,
                                meta: {
                                    title: '채용정보 작성',
                                }
                            },
                            {
                                path: ':id',
                                name: 'CSRecruitInfoDetail',
                                component: CSRecruitInfoDetailView,
                                meta: {
                                    title: '채용정보 상세',
                                }
                            },
                            {
                                path: 'update/:id',
                                name: 'CSRecruitInfoUpdate',
                                component: CSRecruitInfoUpdateView,
                                meta: {
                                    title: '채용정보 수정',
                                }
                            },
                        ]
                    },
                    {
                        path: 'faq',
                        component: RouterView,
                        meta: {
                            title: 'FAQ',
                        },
                        children: [
                            {
                                path: '',
                                name: 'CSFAQList',
                                component: CSFAQListView,
                                meta: {
                                    title: 'FAQ',
                                }
                            },
                            {
                                path: 'create',
                                name: 'CSFAQCreate',
                                component: CSFAQCreateView,
                                meta: {
                                    title: 'FAQ 작성',
                                }
                            },
                            {
                                path: ':id',
                                name: 'CSFAQDetail',
                                component: CSFAQDetailView,
                                meta: {
                                    title: 'FAQ 상세',
                                }
                            },
                            {
                                path: 'update/:id',
                                name: 'CSFAQUpdate',
                                component: CSFAQUpdateView,
                                meta: {
                                    title: 'FAQ 수정',
                                }
                            },
                        ]
                    },
                    {
                        path: 'qna',
                        component: RouterView,
                        meta: {
                            title: 'Q&A',
                        },
                        children: [
                            {
                                path: '',
                                name: 'CSQNAList',
                                component: CSQNAListView,
                                meta: {
                                    title: 'Q&A',
                                }
                            },
                            {
                                path: ':id',
                                name: 'CSQNADetail',
                                component: CSQNADetailView,
                                meta: {
                                    title: 'Q&A 상세',
                                }
                            },
                        ]
                    },
                    {
                        path: 'newsletter',
                        component: RouterView,
                        meta: {
                            title: '뉴스레터',
                        },
                        children: [
                            {
                                path: '',
                                name: 'CSNewsletterList',
                                component: CSNewsletterListView,
                                meta: {
                                    title: '뉴스레터',
                                }
                            },
                            {
                                path: 'create',
                                name: 'CSNewsletterCreate',
                                component: CSNewsletterCreateView,
                                meta: {
                                    title: '뉴스레터 작성',
                                }
                            },
                            {
                                path: ':id',
                                name: 'CSNewsletterDetail',
                                component: CSNewsletterDetailView,
                                meta: {
                                    title: '뉴스레터 상세',
                                }
                            },
                            {
                                path: 'update/:id',
                                name: 'CSNewsletterUpdate',
                                component: CSNewsletterUpdateView,
                                meta: {
                                    title: '뉴스레터 수정',
                                }
                            },
                        ]
                    },
                ]
            },
        ]
    },
]